import APIClient from '@/shared/http/clients/api'

const resourceName = 'mechanicalworkshop'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByName = (name, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/name/${name}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const MechanicalWorkshopRepository = {
  GetAll,
  GetAllPaging,
  GetAllByName,
  GetById,
  Create,
  Update,
  Delete
}

export default MechanicalWorkshopRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/mechanicalworkshop.js